module.exports = __webpack_public_path__ + "common/loading-spinner-31da96bdbc68a98e7104c3b741b8f641.svg";